import { render, staticRenderFns } from "./higsea.vue?vue&type=template&id=ecf51ba0&scoped=true&"
import script from "./higsea.vue?vue&type=script&lang=js&"
export * from "./higsea.vue?vue&type=script&lang=js&"
import style0 from "./higsea.vue?vue&type=style&index=0&id=ecf51ba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf51ba0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecf51ba0')) {
      api.createRecord('ecf51ba0', component.options)
    } else {
      api.reload('ecf51ba0', component.options)
    }
    module.hot.accept("./higsea.vue?vue&type=template&id=ecf51ba0&scoped=true&", function () {
      api.rerender('ecf51ba0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/higsea.vue"
export default component.exports